import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { environment } from '../../../../environments/environment';
import { HelperService } from 'app/shared/services/helper.service';

@Component({
  selector: 'app-transaction-list',
  templateUrl: './transaction-list.component.html',
  styleUrls: [
    './transaction-list.component.scss',
    "../../../../assets/sass/libs/datatables.scss",
  ],
  encapsulation: ViewEncapsulation.None,
})
export class TransactionListComponent implements OnInit {

  ColumnMode = ColumnMode;  // needed for ngx-datatable

  /* ---------------------- INPUTS ------------------------ */
  @Input() listFields: Array<any> = [];
  @Input() dataList: Array<any> = [];

  @Input() limit: number = 10;
  @Input() page: number = 1;
  @Input() listCount: number = 0; // total records from backend

  @Input() editRoutePath: string = '/';
  @Input() viewRoutePath: string = '/';
  @Input() editKey: string = '_id';

  @Input() showAction: any = {
    edit: true,
    view: false,
    delete: false,
    download: false,
  };

  /* ---------------------- OUTPUTS ------------------------ */
  @Output() pageNumber = new EventEmitter<number>();
  @Output() limitChange = new EventEmitter<number>();
  @Output() deleteById = new EventEmitter<any>();
  @Output() downloadPath = new EventEmitter<any>();

  /* ---------------------- PROPERTIES ------------------------ */
  env = environment;
  totalPages = 1;
  pageSizes = [10, 20, 50, 100];

  constructor(public hp: HelperService) { }

  ngOnInit(): void {
    this.calculatePages();
  }

  ngOnChanges(): void {
    this.calculatePages();
  }

  /* ---------------------- FUNCTIONS ------------------------ */

  /** Calculate total pages */
  calculatePages() {
    if (this.listCount > 0 && this.limit > 0) {
      this.totalPages = Math.ceil(this.listCount / this.limit);
    } else {
      this.totalPages = 1;
    }
  }

  /** Emit page number */
  pageChange() {
    this.pageNumber.emit(this.page);
  }

  /** On changing limit */
  limitUpdate() {
    this.page = 1; // reset to first page
    this.calculatePages();
    this.limitChange.emit(this.limit);
  }

  /** Download event */
  download(path: any) {
    this.downloadPath.emit(path);
  }

  /** Delete event */
  deleteService(id: any) {
    this.deleteById.emit(id);
  }

  /** Utility function for fields */
  GetFieldByIndex(r: any, fieldName: any) {
    let string = r[fieldName];
    if (string === undefined) {
      let str = fieldName.split('.');
      let temp = r;
      for (let i = 0; i < str.length; i++) {
        if (temp && temp.hasOwnProperty(str[i])) {
          temp = temp[str[i]];
        } else {
          return "NA";
        }
      }
      string = temp;
    }
    return string;
  }

  /* ---------------------- Pagination Buttons ------------------------ */

  previousPage() {
    if (this.page > 1) {
      this.page--;
      this.pageChange();
    }
  }

  nextPage() {
    if (this.page < this.totalPages) {
      this.page++;
      this.pageChange();
    }
  }


}
